import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AssessmentAreaBasicModel, Form, FormElement, MessagesComponent, OpnTeamMemberModel, OpnTeamMemberSaveModel, OpnTeamMembersService, RequestsService, TranslationManager, ViewState } from 'src/common';
import { ComponentName } from 'src/common/enums/componentsName';
import { UsersActiveEmployeesSelectComponent } from 'src/views';

@Component({
  selector: 'opn-team-member',
  templateUrl: 'opn-team-member.component.html'
})

export class OpnTeamMemberComponent implements OnInit {

  @Input() state: ViewState;
  @ViewChild("usersActiveEmployeesSelectComponent") usersActiveEmployeesSelectComponent: UsersActiveEmployeesSelectComponent;
  translationManager = TranslationManager;
  requestId: number;

  form: Form = new Form();
  viewState = ViewState;
  assessmentAreas: any[] = [];

  selectedAssessmentAreaIds: any[];
  isAssessmentAreaSelectRequired: boolean;
  items: any[];
  show: boolean = false;
  resolve: any;
  isReadonly: boolean = false;

  constructor(private requestsService: RequestsService,
    private opnTeamMembersService: OpnTeamMembersService,
    private route: ActivatedRoute, private location: Location) {
  }

  ngOnInit(): void {
    this.initForm();

  }

  ngAfterViewInit(): void {

  }

  initRequestAssessmentAreas(){
    this.requestsService.getRequestAssessmentAreas(this.requestId).then((items: AssessmentAreaBasicModel[]) => {
      this.assessmentAreas = items;
      this.assessmentAreas.forEach(item => {
        item.name = TranslationManager.getTranslation('AssessmentArea-Name#' + item.id);
      });
    });
  }



  private initForm(): void {
    this.form.elements["employeeId"] = new FormElement();
    this.form.elements["employeeId"].state.mandatory = true;

    this.form.elements["employeeFullName"] = new FormElement();
    this.form.elements["organizationalUnit"] = new FormElement();
    this.form.elements["employeePosition"] = new FormElement();
    this.form.elements["personnelArea"] = new FormElement();
  }

  selectActiveEmployee() {
    this.usersActiveEmployeesSelectComponent.showModal(this.requestId, ComponentName.OpnOfferEvaluationMember + '').then((selectedId: number) => {
      if (selectedId) {
        this.form.elements['employeeId'].value = selectedId;
        let selectedEmployee = this.usersActiveEmployeesSelectComponent.getEmployeeById(selectedId);

        this.form.elements["employeeFullName"].value = selectedEmployee.userFullName;
        this.form.elements["organizationalUnit"].value = selectedEmployee.organizationalUnit;
        this.form.elements["employeePosition"].value = selectedEmployee.employeePosition;
        this.form.elements["personnelArea"].value = selectedEmployee.personnelArea;
      }
    });
  }

  showModal(): Promise<boolean> {
    this.show = true;
    this.selectedAssessmentAreaIds = [];
    this.isAssessmentAreaSelectRequired = false;

    return new Promise((resolve) => {
      this.resolve = resolve;
    });
  }

  createModal(requestId:number): Promise<boolean> {
    this.isReadonly = false;
    this.requestId=requestId;
    this.initRequestAssessmentAreas();

    this.form.elements['employeeId'].value = null;
    this.form.elements['employeeId'].value = undefined;
    this.form.elements['employeeFullName'].value = undefined;
    this.form.elements['organizationalUnit'].value = undefined;
    this.form.elements['employeePosition'].value = undefined;
    this.form.elements['personnelArea'].value = undefined;

    return this.showModal();
  }

  editModal(teamMember: OpnTeamMemberModel,requestId:number): Promise<boolean> {
    this.isReadonly = true;
    this.requestId=requestId;
    this.initRequestAssessmentAreas();

    this.form.elements['employeeId'].value = teamMember.userId;
    this.form.elements["employeeFullName"].value = teamMember.fullName;
    this.form.elements["organizationalUnit"].value = teamMember.organizationalUnit;
    this.form.elements["employeePosition"].value = teamMember.employeePosition;
    this.form.elements["personnelArea"].value = teamMember.personnelArea;

    return this.showModal();
  }

  close() {
    this.show = false;
    if (this.resolve) {
      this.resolve(false);
    }
  }

  submit() {

    this.isAssessmentAreaSelectRequired = !this.selectedAssessmentAreaIds || this.selectedAssessmentAreaIds.length == 0;
    if (this.form.isValid() && !this.isAssessmentAreaSelectRequired) {
      let model: OpnTeamMemberSaveModel = new OpnTeamMemberSaveModel();
      model.requestId = this.requestId;
      model.userId = this.form.elements['employeeId'].value;
      model.selectedAssessmentAreaIds = this.selectedAssessmentAreaIds;

      this.opnTeamMembersService.save(model).then(() => {
        this.show = false;
        if (this.resolve) {
          this.resolve(true);
        }
      }).catch((reason: any) => {
        MessagesComponent.instance.showError([reason.error.messages]);
      });
    }

  }

  navigateToList() {
    this.location.back();
  }
}
